<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosRatingRules"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button
                type="link"
                @click="addEdit(record)"
                v-permission="
                  pageType === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_edit_btn' : 'ofbu_ratingrules_edit_btn'
                "
                >{{ t('btn.edit') }}</a-button
              >
              <a-button
                type="link"
                @click="deleteRow(record)"
                v-permission="
                  pageType === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_delete_btn' : 'ofbu_ratingrules_delete_btn'
                "
                >{{ t('btn.del') }}</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button
            type="primary"
            @click="addEdit()"
            v-permission="
              pageType === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_add_btn' : 'ofbu_ratingrules_add_btn'
            "
            >{{ t('btn.add') }}</a-button
          >
        </template>
      </cos-table>
      <editModal ref="editModalRef" :pageType="pageType" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ratingRulesFindByPage, ratingRulesDelete } from '@/api/overseasSales/ratingRules'
import { PageType } from './hooks/enum'
import { RatingRulesSaveParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

export default { name: 'DcCosOFbuRatingRules' }
</script>
<script setup lang="ts">
const route = useRoute()
const { t } = useI18n()
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: RatingRulesSaveParams) => void }>()
const pageType = computed(() => route.path.split('/').pop() || 'ratingRules')
const columns = computed(() => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    return [
      { title: t('operate.g9b9mu'), dataIndex: 'configName' },
      {
        title: pageType.value === 'volumeOfBusinessLevel' ? t('operate.sezilm') : t('operate.v73rkj'),
        dataIndex: 'logic'
      },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right'
      }
    ]
  } else {
    return [
      { title: t('operate.8u7ow3'), dataIndex: 'configName' },
      { title: t('operate.gihkns'), dataIndex: 'logic' },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right'
      }
    ]
  }
})

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    ratingRulesFindByPage({ ...params, configType: PageType.LEVEL, appId: 'cos_ofbu' }).then((res) => {
      callBack(res)
    })
  } else {
    ratingRulesFindByPage({ ...params, configType: PageType.RULE, appId: 'cos_ofbu' }).then((res) => {
      callBack(res)
    })
  }
}
const success = () => {
  tableRef.value.fetch()
}

const addEdit = (_row?: RatingRulesSaveParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: RatingRulesSaveParams) => {
  Modal.delete({
    name: row.configName,
    onOk() {
      ratingRulesDelete({ id: row.id }).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value.fetch()
      })
    }
  })
}
</script>

<style scoped></style>
